import BfvLazyloadHtml from '../BfvLazyloadHtml';

/**
 * Class is mostly the same as LazyLoadHtml but listens for some custom Event
 */
class BfvLazyLoadHtmlEvent extends BfvLazyloadHtml {
  contentHasLoaded = false;

  constructor(options = {}) {
    super(options);
    this.$root = options.element;
    this.loadContent = this.loadContent.bind(this);
  }

  /**
   * overwrite for the {@link BfvLazyloadHtml.init|BfvLazyloadHtml.init()}
   */
  init() {
    document.addEventListener('bfvOverlay:opened', this.loadContent);
  }

  /**
   * runs after Event was dispatched
   * runs the inti() from parent class that loads the API content
   * @see BfvLazyloadHtml
   * @param event
   * @returns {Promise<void>}
   */
  async loadContent(event) {
    if (this.contentHasLoaded) {
      return;
    }
    try {
      await super.init();
      document.removeEventListener('bfvOverlay:opened', this.loadContent);
      this.contentHasLoaded = true;
    } catch (error) {
      this.contentHasLoaded = false;
      // <editor-fold defaultstate="collapsed" desc="-- notification --">
      // @formatter:off
      /* eslint-disable */
      console.groupCollapsed('cannot load Api');
        console.log('Error', error);
        console.log('Api: ', this.apiName);
        console.log('Event', event);
      console.groupEnd();
      /* eslint-enable */
      // @formatter:on
      // </editor-fold>
    }
  }
}

export default BfvLazyLoadHtmlEvent;
